import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="w-full bg-[#1B2A4A] text-white" data-id="element-140">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20" data-id="element-141">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-142">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-143">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6 leading-tight" data-id="element-144">
              ¿Tu Entrevista de Ciudadanía es Pronto y Todavía Sientes que No
              Estás Listo?
            </h1>

            <h2 className="text-xl sm:text-2xl mb-8 text-gray-200 font-normal" data-id="element-145">
              Descubre el Sistema Exacto que Está Ayudando a Inmigrantes
              Hispanohablantes a Dominar las 100 Preguntas Oficiales… Sin Morir
              de los Nervios en el Intento
            </h2>

            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} onClick={() => document.getElementById('buy-button')?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })} className="bg-[#C9A84C] text-[#1B2A4A] px-8 py-4 rounded-lg font-bold text-lg hover:bg-[#d4b35c] transition-colors w-full sm:w-auto" data-id="element-146">
              DESCARGAR MI GUÍA AHORA
            </motion.button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="order-first lg:order-last" data-id="element-147">
            <img src="https://cdn.magicpatterns.com/uploads/b3PDGtW22NDZoy2m7HU1BD/heylloyd-image-1776668507304.png" alt="Mujer sonriente sosteniendo tablet con guía de ciudadanía" className="w-full h-auto rounded-lg shadow-2xl" data-id="element-148" />
          </motion.div>
        </div>
      </div>
    </section>;
}